import React from 'react';
import './InfoBanner.scss';
import { IconInfo } from '../Icons';

interface InfoBannerProps {
  title: string | React.ReactNode;
}
export default function InfoBanner({ title }: InfoBannerProps): React.ReactElement {
  return (
    <div className="info-banner">
      <span className="info-banner__icon">
        <IconInfo />
      </span>
      <span dangerouslySetInnerHTML={{ __html: title }} />
    </div>
  );
}
